<div>
  <div class="girdle">
    <img src="../../../assets/new/bottom-banner.png">
  </div>
  <div class="bottom">
    <img src="../../../assets/images/shouye/logo.png" >
    <div class="contact">
      <span style="color: #333333;font-family: Microsoft YaHei UI;">Thank you for your interest in the HOW2025 Eco Conference. </span><br>
      <span style="color: #333333;font-family: Microsoft YaHei UI;">For any conference-related inquiries, please email: conference@ivorysql.org</span> <br>
      <a href="http://beian.miit.gov.cn/">鲁ICP备09010331号</a>
    </div>
    <div style="text-align:center;">
      <img src="../../../assets/images/shouye/qrcode.jpg" width="100px">
      <div>Scan the QR code to stay updated on the conference. </div>
    </div>
  </div>
  <hr>
</div>
